import * as React from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'hooks/use-redux'
import { openTrackRoute } from '@disco/state-management/actions/ExplorerActions'

export default function TrackRedirect() {
  const { trackId } = useParams<{ trackId: string }>()
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (trackId) {
      dispatch(openTrackRoute(parseInt(trackId)))
    }
  }, [trackId, dispatch])

  return null
}
